import { Button, Form, Input, Modal, Space, Switch } from 'antd';
import React, { useState } from 'react';
import { AOS_VALIDATION_MESSAGES } from '../../../../common/constants';
import CommonSelect from '../../../../components/CommonSelect';
import { USERS } from '../graphql/Queries';

function StreamModal({ form, open, editRecord, loading, onFinish, onCancel }) {
  const [streamLeadSearch, setStreamLeadSearch] = useState('');
  const [deliveryManagerSearch, setDeliveryManagerSearch] = useState('');

  const streamLeadOptions = editRecord?.streamLead
    ? [
        {
          id: editRecord.streamLeadId,
          displayName: `${editRecord.streamLead.firstName} ${editRecord.streamLead.lastName}`,
        },
      ]
    : [];

  const deliveryManagerOptions = editRecord?.deliveryManager
    ? [
        {
          id: editRecord.deliveryManagerId,
          displayName: `${editRecord.deliveryManager.firstName} ${editRecord.deliveryManager.lastName}`,
        },
      ]
    : [];

  return (
    <Modal
      title={editRecord ? 'Edit Stream' : 'New Stream'}
      open={open}
      onCancel={onCancel}
      footer={null}
      destroyOnClose
      afterClose={() => {
        form.resetFields();
        setStreamLeadSearch('');
        setDeliveryManagerSearch('');
      }}
    >
      <Form form={form} layout="vertical" onFinish={onFinish}>
        <Form.Item
          name="name"
          label="Stream Name"
          rules={[
            {
              required: true,
              message: AOS_VALIDATION_MESSAGES.STREAM_NAME_REQUIRED,
            },
          ]}
        >
          <Input placeholder="Name" maxLength={255} />
        </Form.Item>
        <Form.Item
          name="streamLeadId"
          label="Stream Lead"
          rules={[
            {
              required: true,
              message: AOS_VALIDATION_MESSAGES.STREAM_LEAD_REQUIRED,
            },
          ]}
        >
          <CommonSelect
            placeholder="Select Lead"
            showSearch
            allowClear
            query={USERS}
            responsePath="users.users"
            valuePath="id"
            labelPath="displayName"
            customOptions={streamLeadOptions}
            conditionToCheckBeforeQuery={open}
            onSearch={setStreamLeadSearch}
            variables={{
              filters: {
                searchStrings: streamLeadSearch ? [streamLeadSearch] : [],
              },
            }}
            useEffectDeps={[streamLeadSearch]}
          />
        </Form.Item>
        <Form.Item name="deliveryManagerId" label="Delivery Manager">
          <CommonSelect
            placeholder="Select Delivery Manager"
            showSearch
            allowClear
            query={USERS}
            responsePath="users.users"
            valuePath="id"
            labelPath="displayName"
            customOptions={deliveryManagerOptions}
            conditionToCheckBeforeQuery={open}
            onSearch={setDeliveryManagerSearch}
            variables={{
              filters: {
                searchStrings: deliveryManagerSearch
                  ? [deliveryManagerSearch]
                  : [],
              },
            }}
            useEffectDeps={[deliveryManagerSearch]}
          />
        </Form.Item>
        {editRecord && (
          <Form.Item name="isActive" label="Active" valuePropName="checked">
            <Switch />
          </Form.Item>
        )}
        <Form.Item>
          <Space>
            <Button type="primary" htmlType="submit" loading={loading}>
              {editRecord ? 'Save' : 'Create'}
            </Button>
            <Button onClick={onCancel}>Cancel</Button>
          </Space>
        </Form.Item>
      </Form>
    </Modal>
  );
}

export default StreamModal;
